module.exports = __webpack_public_path__ + "static/asiatica200_1-3cee34a5ecfa2caccd9150658a81904c.png";